// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-name,
.date,
.role,
.item {
    color: white;
}

.company-name {
    margin-top: 40px;
    text-align: center;
    font-size: 50px;
    font-weight: 600;
    background-image: linear-gradient(to left, #553c9a, #b393d3);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
}

.date {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    background-image: linear-gradient(to left, #a5a5a6, #beaece);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
}

.location {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    background-image: linear-gradient(to left, #a5a5a6, #beaece);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
}

.role {
    margin-top: 10px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    background-image: linear-gradient(to left, #a5a5a6, #beaece);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
}

li {
    margin-top: 10px;
    text-align: left;
    font-size: 20px;
    font-weight: 400;
    background-image: linear-gradient(to left, #a5a5a6, #beaece);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
}

ul {
    list-style-type: disc;
    list-style-position: outside;
}`, "",{"version":3,"sources":["webpack://./src/css/employment.css"],"names":[],"mappings":"AAAA;;;;IAII,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC","sourcesContent":[".company-name,\n.date,\n.role,\n.item {\n    color: white;\n}\n\n.company-name {\n    margin-top: 40px;\n    text-align: center;\n    font-size: 50px;\n    font-weight: 600;\n    background-image: linear-gradient(to left, #553c9a, #b393d3);\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n}\n\n.date {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 600;\n    background-image: linear-gradient(to left, #a5a5a6, #beaece);\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n}\n\n.location {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 600;\n    background-image: linear-gradient(to left, #a5a5a6, #beaece);\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n}\n\n.role {\n    margin-top: 10px;\n    text-align: center;\n    font-size: 30px;\n    font-weight: bold;\n    background-image: linear-gradient(to left, #a5a5a6, #beaece);\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n}\n\nli {\n    margin-top: 10px;\n    text-align: left;\n    font-size: 20px;\n    font-weight: 400;\n    background-image: linear-gradient(to left, #a5a5a6, #beaece);\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n}\n\nul {\n    list-style-type: disc;\n    list-style-position: outside;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
